import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";
import Box from "@mui/material/Box";

export const StyledLabel = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  color: "#555",
  fontSize: "16px",
  fontWeight: "700",
  lineHeight: "20px",
  marginBottom: "8px",
  display: "flex",
  alignItems: "center",
  gap: "5px",
  ...sx,
}));

export const StyledDashBar = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  height: "1px",
  width: "30px",
  backgroundColor: "#E2E0E0",
  ...sx,
}));
